module.exports = __webpack_public_path__ + "img/chart_add.cdebfb1d.svg";